import { render, staticRenderFns } from "./ReportScoreGroupRankiframe.vue?vue&type=template&id=20dc7c69"
import script from "./ReportScoreGroupRankiframe.vue?vue&type=script&lang=js"
export * from "./ReportScoreGroupRankiframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports